<template>
  <div>
    <div class="header mb-4">
      <a href="#" class="btn bg-white float-end" @click.prevent="add_new = true">Add New<i class="fal fa-plus me-0 ms-2"></i></a>
      <h1 class="header-title">Qualities</h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Qualities</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="! loading">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Stars</th>
                  <th colspan="2"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="qualities.length == 0">
                  <td colspan="6">There is no data to display.</td>
                </tr>
                <tr v-for="(quality, i) in qualities" :key="`quality-${i}`">
                  <td>{{ i+1 }}</td>
                  <td>{{ quality.name }}</td>
                  <td>{{ quality.description }}</td>
                  <td>{{ quality.stars }}</td>
                  <td width="20px">
                    <a href="#" @click.prevent="editing = quality; show_edit = true"><i class="fa fa-pencil"></i></a>
                  </td>
                  <td width="20px">
                    <a href="#" @click.prevent="are_you_sure = true; deleting = quality"><i class="fa fa-trash"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <loading v-if="loading" />
        </div>
      </div>
    </div>
    <modal :show="show_edit" @close="show_edit = false">
      <template slot="header">Edit Quality</template>
      <form @submit.prevent="update" id="update_form">
        <div class="mb-3">
          <label>Name</label>
          <input type="text" name="name" placeholder="Quality Name" class="form-control" v-model="editing.name">
        </div>
        <div class="mb-3">
          <label>Description</label>
          <textarea placeholder="Quality Name" name="description" class="form-control" v-model="editing.description" rows="2"></textarea>
        </div>
        <div class="mb-3">
          <label>Stars</label>
          <select class="form-control" v-model="editing.stars" name="stars">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
        </div>
        <div class="text-end">
          <button class="btn btn-primary">Save<i class="fal fa-save me-0 ms-2"></i></button>
        </div>
      </form>
    </modal>

    <are-you-sure @cancel="are_you_sure = false" :show="are_you_sure" @confirm="destroy(deleting)" id="delete_item" />
    
    <modal :show="add_new" @close="add_new = false">
      <template slot="header">Add Quality</template>
      <form @submit.prevent="create" id="create_form">
        <div class="mb-3">
          <label>Name</label>
          <input type="text" placeholder="Quality Name" class="form-control" v-model="new_cat.name" name="name">
        </div>
        <div class="mb-3">
          <label>Description</label>
          <textarea placeholder="Quality Name" class="form-control" v-model="new_cat.description" rows="2" name="description"></textarea>
        </div>
        <div class="mb-3">
          <label>Stars</label>
          <select class="form-control" v-model="new_cat.stars" name="stars">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
        </div>
        <div class="text-end">
          <button class="btn btn-primary">Save<i class="fal fa-save me-0 ms-2"></i></button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch()
  },

  data() {
    return {
      loading: true,
      qualities: [],
      editing: {},
      show_edit: false,
      are_you_sure: false,
      deleting: {},
      add_new: false,
      new_cat: { stars: 1 }
    }
  },

  methods: {
    fetch() {
      this.loading = true

      this.$axios.get('/api/v1/admin/qualities').then(response => {
        this.qualities = response.data.qualities
        this.loading = false
      })
    },

    destroy(quality) {
      let data = {
        form_id: 'delete_item'
      }

      this.$axios.delete(`/api/v1/admin/qualities/${quality.id}`, data).then(() => {
        this.are_you_sure = false
        this.fetch()
      })
    },

    update() {
      let data = {
        form_id: 'update_form',
        name: this.editing.name,
        description: this.editing.description,
        stars: this.editing.stars,
      }

      this.$axios.put(`/api/v1/admin/qualities/${this.editing.id}`, data).then(() => {
        this.show_edit = false
        this.fetch()
      })
    },

    create() {
      let data = {
        form_id: 'create_form',
        name: this.new_cat.name,
        description: this.new_cat.description,
        stars: this.new_cat.stars,
      }

      this.$axios.post(`/api/v1/admin/qualities`, data).then(() => {
        this.add_new = false
        this.fetch()
      })
    }
  }
};
</script>